export const reorderItems = (items: any[], startIndex: number, endIndex: number): any[] => {
  if (startIndex === endIndex) return items;

  const result = [...items];
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};
